<template>
    <div>
        <v-menu
            :close-on-content-click="false"
            v-model="menu"
            :close-on-click="menuCloseOnClick"
            transition="scale-transition"
            offset-y
            min-width="auto"
            :left="menuLeftProp"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-combobox
                    x-large
                    readonly
                    v-bind="$attrs"
                    v-on="on"
                    v-model.lazy="dateRangeText"
                    append-icon="mdi-menu-down"
                    :class="targetClass"
                    :outlined="isOutlined"
                    :label="displayLabel"
                    @click:clear="handleClear"
                >
                </v-combobox>
            </template>
            <v-date-picker
                v-model.lazy="date_temp"
                no-title
                scrollable
                :active-picker.sync="activePicker_local"
                :reactive="getInitialReactiveState()"
                v-bind="$attrs"
                :range="isRange"
                :min="min"
                :max="max"
                @change="handleOK"
                v-on="$listeners"
                @update:picker-date="yearSelected"
                ref="date_picker_component"
            >
                <v-spacer></v-spacer>
                <v-btn v-show="!is_readonly"
                       text
                       color="primary"
                       @click="handleCancel"
                >
                    {{$page.language.buttons.BUTTON_CANCEL}}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn v-show="!is_readonly"
                       text
                       color="primary"
                       @click="handleClear"
                       v-bind="$attrs"
                >
                    {{$page.language.buttons.BUTTON_CLEAR}}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn v-show="!is_readonly"
                       text
                       color="primary"
                       @click="handleOK"
                       v-bind="$attrs"
                >
                    {{$page.language.buttons.BUTTON_OK}}
                </v-btn>
            </v-date-picker>
        </v-menu>
    </div>
</template>
<script>
export default {
    name: "DatePicker",
    inheritAttrs: false,
    props: {
        'value':{
            required: false,
            default: function () {
                return undefined
            }
        },
        'targetClass':{
            type: String,
            required: false,
            default: function () {
                return undefined
            }
        },
        'isOutlined':{
            type: Boolean,
            required: false,
            default: function () {
                return true
            }
        },
        'yearOnly':{
            type: Boolean,
            required: false,
            default: function () {
                return false
            }
        },
        'isRange':{
            type: Boolean,
            required: false,
            default: function () {
                return this.yearOnly
            }
        },
        'displayLabel': {
            type: String,
            required: false,
            default: function () {
                return undefined
            }
        },
        'min': {
            type: String,
            required: false,
            default: function () {
                return undefined
            }
        },
        'max': {
            type: String,
            required: false,
            default: function () {
                return undefined
            }
        },
        'menuCloseOnClick':{
            type: Boolean,
            required: false,
            default: function () {
                return true
            }
        },
        'left': {
            type: Boolean,
            required: false,
            default: function () {
                return undefined;
            }
        },

    },
    data() {
        return {
            date: this.value? this.getAsIsoDate(this.value) || null : null,
            date_temp: this.value? this.getAsIsoDate(this.value) || null : null,
            menu: false,
            activePicker_local: this.getInitialMode(),
        }
    },
    computed: {
        label: function () {
            return this.date ?? null
        },
        is_readonly: function () {
            return this.$attrs['readonly']
        },
        dateRangeText: {
            get() {
                if(this.yearOnly) {
                    let date = Array.isArray(this.date_temp) ? this.date_temp[0] : this.date_temp
                    return date?.split('-')[0]
                }
                if(this.isRange) {
                    return this.date_temp?.sort().join(' - ')
                }
                else {
                    return this.date_temp
                }
            },
            set() {
            }
        },
        menuLeftProp() {
            return this.left ? true : undefined;
        },
    },
    methods: {
        getDefaultDate() {
            return (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
        },
        getInitialMode() {
            if (this.yearOnly) return 'YEAR'
            return this.$attrs['active-picker'] || 'DATE'
        },
        getInitialReactiveState() {
            if (this.yearOnly) return true
            return this.$attrs['reactive'] || false
        },
        getAsIsoDate(datestring) {
            let mom = moment(datestring)
            let valid_check = mom?.isValid()
            return valid_check ? mom.format('Y-MM-DD') : null
        },
        handleOK() {
            this.date = this.date_temp
            this.$emit('input', this.date)
            this.closeMenu()
        },
        handleCancel() {
            this.date_temp = this.date
            this.closeMenu()
        },
        handleClear() {
            this.date = null
            this.date_temp = null
            this.$emit('input', this.date)
            this.closeMenu()
        },
        closeMenu() {
            this.$nextTick(()=>{
                this.menu = false
            })
        },
        yearSelected(new_value) {
            if (this.yearOnly) {

                let date_massaged = Array.isArray(new_value) ? new_value[0] : new_value
                let year = date_massaged.split('-')[0] || null
                if (!year) {
                    return null
                }
                this.$emit('input', [`${year}-01-01`, `${year}-12-31`])
                this.closeMenu()
            }
        },
    },
    watch: {

        value: {
            immediate: false,
            handler: function(new_value) {
                this.date = new_value
                this.date_temp = new_value
            }
        },


        menu (val) {
            val && setTimeout(() => (this.activePicker_local = this.getInitialMode()), 10)
        },
    },
}
</script>

<style>

filter.v-text-field>.v-input__control>.v-input__slot:before {
    border-style: none;
}
filter.v-text-field>.v-input__control>.v-input__slot:after {
    border-style: none;
}

</style>
